import React, { useState, useEffect } from "react";
import logo from "../../assets/images/maersk-logo.png";
import { useStore } from "../../store/store.context";
import { useAuth } from "../../hooks/useAuth";
import "./top-bar.scss";
// import logoutLogo from "../files/Denskat.png"; // Adjust the path according to your project structure
import "@maersk-global/mds-components-core/mc-icon";
import "@maersk-global/mds-components-core/mc-tab-bar";
import "@maersk-global/mds-components-core/mc-tab";
import { McTab } from "@maersk-global/mds-react-wrapper/components-core/mc-tab";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";
import { useNavigate } from "react-router-dom";
import { McAvatar, McTabBar } from "@maersk-global/mds-react-wrapper";
// import { useMsal } from '@azure/msal-react';
// import { loginRequest } from '../authConfig';
// import { callMsGraph } from '../graph';

import InfoModal from '../info-modal';

const Header = () => {
  const { store, updateStore } = useStore();
  const { activeTab } = store;
  const { user, isLoading, isAuthenticated, error, login, refresh, refreshUserPhoto, logout } = useAuth();
  
  // State for user profile dropdown
  const [showUserProfile, setShowUserProfile] = useState(false);

  // Debug: Log user data to see what's available
  useEffect(() => {
    if (user) {
      console.log('Header: User data received:', {
        name: user.name,
        email: user.email,
        photo: user.photo,
        hasPhoto: !!user.photo,
        photoType: typeof user.photo
      });
    }
  }, [user]);

  // Listen for photo updates
  useEffect(() => {
    const handlePhotoUpdate = () => {
      console.log('Photo update event received, refreshing user data');
      // Force refresh of user data from session storage
      try {
        const updatedUserInfo = sessionStorage.getItem('userInfo');
        if (updatedUserInfo) {
          const userData = JSON.parse(updatedUserInfo);
          console.log('Updated user data with photo:', userData.photo ? 'Photo available' : 'No photo');
          // The useAuth hook should handle this automatically, but we can force a refresh if needed
          if (refreshUserPhoto && typeof refreshUserPhoto === 'function') {
            refreshUserPhoto();
          }
        }
      } catch (error) {
        console.error('Error handling photo update:', error);
      }
    };

    window.addEventListener('userPhotoUpdated', handlePhotoUpdate);
    return () => window.removeEventListener('userPhotoUpdated', handlePhotoUpdate);
  }, [refreshUserPhoto]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside the user profile dropdown
      if (showUserProfile && !event.target.closest('.user-profile-container')) {
        setShowUserProfile(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showUserProfile]);

  const handleTabClick = (tabId) => {
    updateStore({ activeTab: tabId });
  };
  //   useEffect(() => {
  //     if (accounts.length > 0) {
  //       // Silently acquire an access token to call Microsoft Graph
  //       instance.acquireTokenSilent({
  //         ...loginRequest,
  //         account: accounts[0],
  //       })
  //       .then((response) => {
  //         // Fetch user profile data including name and photo
  //         callMsGraph(response.accessToken).then((response) => {
  //           setGraphData({
  //             name: response.displayName,  // User's name
  //             photo: response.photo        // User's profile photo URL
  //           });
  //           sessionStorage.setItem("username", JSON.stringify(response.displayName));
  //         });
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching MS Graph data: ", error);
  //       });
  //     }
  //   }, [accounts, instance]);

  const headerStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    top: 0,
    zIndex: 1000,
    width: "100%",
    height: "60px",
  position: "fixed",
  left: 0,
  color: "#00243D",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    fontFamily: "Maersk Text",
  };

  const logoStyles = {
    height: "26px",
    marginRight: "20px",
  };

  const userPhotoStyles = {
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    marginRight: "0px",
  };
  const navigate = useNavigate();

  // Central tab change handler (also toggle chat/prompt visibility if needed)
  const handleTabChange = (tab) => {
    // If switching to Cargo Mate we want to fully reset prompt/message/dashboard-related state
    if (tab === 'cargo-mate') {
      try {
        updateStore({
          // show Cargo Mate tab and message panel
          activeTab: 'cargo-mate',
          showMessagePanel: true,
          // show prompt panel (Sample Prompts)
          prompt: true,
          // clear any API response / loading / dashboard state so PromptPanel renders
          apiResponseData: null,
          loading: false,
          dashboardStatus: "",
          caseId: "",
          initialCaseSelect: false,
          // reset navigation history so back navigation is cleared
          navigationHistory: {
            previousView: null,
            canGoBack: false,
          },
          // also clear prompt query and temporary message flags
          promptQuery: "",
          previousSendMessage: false,
          // reset status block
          status: {
            mail: false,
            casestatus: "",
            mailContent: "",
          },
        });
        // Notify other components (Home/PromptPanel) to reset their local API state
        try {
          window.dispatchEvent(new Event('backToSamplePrompts'));
        } catch (e) {
          console.warn('Could not dispatch backToSamplePrompts event', e);
        }
      } catch (err) {
        // updateStore may not be available in some contexts; swallow safely
        console.warn('updateStore not available when switching to cargo-mate', err);
      }
      return;
    }

    // Default behavior for other tabs
    updateStore({
      activeTab: tab,
      showMessagePanel: tab === "cargo-mate",
      prompt: tab === "cargo-mate"
    });
  };

  // Function to handle user avatar click
  const handleUserClick = () => {
    if (isAuthenticated && user) {
      setShowUserProfile(!showUserProfile);
    } else {
      login();
    }
  };

  // Function to handle logout
  const handleLogout = () => {
    setShowUserProfile(false);
    if (logout) {
      logout();
    }
  };

  // User profile dropdown component
  const UserProfileDropdown = () => {
    if (!showUserProfile || !user) return null;

    return (
      <div className="user-profile-dropdown">
        {/* User Info Section */}
        <div className="profile-header">
          {user.photo ? (
            <img 
              src={user.photo} 
              alt="User Profile" 
              className="profile-avatar"
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%'
              }}
            />
          ) : (
            <McAvatar 
              info={user.initials || "U"} 
              hiddentooltip={true}
              fit="medium" 
              appearance="color-3"
              className="profile-avatar"
            />
          )}
          <div className="profile-info">
            <div className="profile-name">
              {user.fullName || user.name || 'User'}
            </div>
            <div className="profile-email">
              {user.email || 'No email available'}
            </div>
            {user.jobTitle && (
              <div className="profile-job-title">
                {user.jobTitle}
              </div>
            )}
          </div>
        </div>

        {/* Additional Info */}
        {/* {(user.department || user.officeLocation) && (
          <div className="profile-details">
            {user.department && (
              <div className="profile-detail-item">
                <strong>Department:</strong> {user.department}
              </div>
            )}
            {user.officeLocation && (
              <div className="profile-detail-item">
                <strong>Location:</strong> {user.officeLocation}
              </div>
            )}
          </div>
        )} */}

        {/* Action Buttons */}        
        <div className="profile-actions">          
            {/* <McIcon icon="rotate" size="24" style={{ cursor: "pointer" }} onClick={() => {
              setShowUserProfile(false);
              if (refreshUserPhoto && typeof refreshUserPhoto === 'function') {
                refreshUserPhoto();
              }
            }}/>             */}
            <span>Logout</span>
            <McIcon icon="door-arrow-right" style={{ cursor: "pointer" }} size="24" onClick={handleLogout} />          
        </div>
      </div>
    );
  };

  return (
    <header className="custom-header" style={headerStyles}>
        
 
         <div style={{display:'flex',alignItems:'center'}}>
        <img src={logo} alt="Company Logo" style={logoStyles} />
        <div
          className="productName"
          onClick={() => {
            // Navigate to home and fully reset Cargo Mate / prompt state (mirror Back to Sample Prompts)
            navigate('/');
            try {
              updateStore({
                // show Cargo Mate tab and message panel
                activeTab: 'cargo-mate',
                showMessagePanel: true,
                // show prompt panel (Sample Prompts)
                prompt: true,
                // clear any API response / loading / dashboard state so PromptPanel renders
                apiResponseData: null,
                loading: false,
                dashboardStatus: "",
                caseId: "",
                initialCaseSelect: false,
                // reset navigation history so back navigation is cleared
                navigationHistory: {
                  previousView: null,
                  canGoBack: false,
                },
                // also clear prompt query and temporary message flags
                promptQuery: "",
                previousSendMessage: false,
                // reset status block
                status: {
                  mail: false,
                  casestatus: "",
                  mailContent: "",
                },
              });
              // Notify other components (Home) to reset their local API state (mirrors Back to Sample Prompts)
              try {
                window.dispatchEvent(new Event('backToSamplePrompts'));
              } catch (e) {
                console.warn('Could not dispatch backToSamplePrompts event', e);
              }
            } catch (err) {
              // updateStore may not be available in some contexts; swallow safely
              console.warn('updateStore not available when navigating home', err);
            }
          }}
          title="Go to home"
          style={{ cursor: 'pointer', marginLeft: '8px' }}
        >
          Approval Freight Release
        </div>
       </div>
        <div style={{ display: "flex", alignItems: "center" ,margin:'auto'}}>
          {/**
           * Map activeTab string -> index. Previously hardcoded to only two states, causing Cargo Mate to stay highlighted.
           */}
          {(() => {
            const tabOrder = ["metrics-snapshot", "cargo-mate", "advanced-search"]; // maintain order here
            const currentIndex = tabOrder.indexOf(activeTab);
            return (
              <McTabBar currentindex={currentIndex < 0 ? 0 : currentIndex} fit="small">
                <McTab
                  slot="tab"
                  label=""
                  icon="chart-bars-vertical"
                  onClick={() => handleTabChange("metrics-snapshot")}
                >
                  Metrics Snapshot
                </McTab>
                <McTab
                  slot="tab"
                  label=""
                  icon="chatbot"
                  onClick={() => handleTabChange("cargo-mate")}
                >
                  Cargo Mate
                </McTab>
                <McTab
                  slot="tab"
                  label=""
                  icon="briefcase"
                  onClick={() => handleTabChange("advanced-search")}
                >
                  Case Activity Log
                </McTab>
              </McTabBar>
            );
          })()}
        </div>
        <div style={{display: "flex", alignItems: "center", gap: "20px"}}> <InfoModal /></div>
        {isLoading ? (
          <McAvatar 
            info="..." 
            hiddentooltip={false}
            fit="small" 
            appearance="color-3"
            tooltip="Loading user information..."
          />
        ) : error ? (
          <McAvatar 
            info="!" 
            hiddentooltip={false}
            fit="small" 
            appearance="color-1"
            tooltip={`Error: ${error}`}
            onClick={handleUserClick}
            style={{ cursor: "pointer" }}
          />
        ) : !isAuthenticated ? (
          <div onClick={handleUserClick} style={{ cursor: "pointer" }} title="Click to sign in">
            <McAvatar 
              info="?" 
              hiddentooltip={false}
              fit="small" 
              appearance="color-2"
              tooltip="Click to sign in"
            />
          </div>
        ) : user && user.photo ? (
          <div className="user-profile-container" style={{ position: 'relative', display: 'flex', marginRight: '10px', gap: '10px' }}>
           
            <div style={{display: 'grid'}}>
              <span>{user.fullName}</span>
              <span style={{fontSize: 'smaller', color: '#6A6A6A'}}>{new Date().toLocaleString()}</span>
            </div>
            <div 
              style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              onClick={handleUserClick}
              title="Click to view profile"
            >
              <img 
                src={user.photo} 
                alt="User Profile" 
                style={userPhotoStyles}
                onError={(e) => {
                  // Fallback to avatar if image fails to load
                  console.log('User photo failed to load, falling back to avatar. Photo URL was:', user.photo);
                  e.target.style.display = 'none';
                  // Show the avatar instead
                  const avatar = e.target.nextSibling;
                  if (avatar) {
                    avatar.style.display = 'block';
                  }
                }}
                onLoad={() => {
                  console.log('User photo loaded successfully');
                }}
              />
              <McAvatar 
                info={user && user.initials ? user.initials : "U"} 
                hiddentooltip={false}
                fit="small" 
                appearance="color-3"
                tooltip={user && user.fullName ? user.fullName : "User"}
                style={{ display: 'none' }}
              />
            </div>
            <UserProfileDropdown />
          </div>
        ) : (
          <div className="user-profile-container" style={{ position: 'relative' }}>
            <div onClick={handleUserClick} style={{ cursor: "pointer" }} title="Click to view profile">
              <McAvatar 
                info={user && user.initials ? user.initials : "U"} 
                hiddentooltip={false}
                fit="small" 
                appearance="color-3"
                tooltip={user && user.fullName ? user.fullName : "User"}
              />
            </div>
            <UserProfileDropdown />
          </div>
        )}
        {/* <a onClick={()=>navigate('/') }><b><u>DenSkat</u></b></a> */}
    
      {/* Display user photo and name in the header */}

      {/* {graphData.name ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          {graphData.photo ? (
            <img src={graphData.photo} alt="User Profile" style={userPhotoStyles} />
          ) : (
            <McIcon icon="user-circle" size="large"></McIcon> // Fallback icon if photo is not available
          )}
          <McTab slot="tab" label={graphData.name}></McTab>
        </div>
      ) : (
        <McTab slot="tab" label={accounts[0]?.name} icon="user-circle"></McTab>
      )} */}
    </header>
  );
};

export default Header;
